export default __webpack_public_path__ + "static/team-chat-b3e46a890d2073f78d4ea5560c9c5974.wav";